import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Toggle from './../Toggle';
import MaterialSelector from './../MaterialSelector';
import { withTranslation, Trans } from 'react-i18next';
import { ownerscabinImageOptions } from './views/ownerscabin'

class X56OwnersCabin extends Component {
    constructor(props) {
        super(props);
        this.handleCupboardsChange = this.handleCupboardsChange.bind(this);
        this.handleFabricChange = this.handleFabricChange.bind(this);
        this.handleBeautytableChange = this.handleBeautytableChange.bind(this);
        this.handleWardrobeChange = this.handleWardrobeChange.bind(this);
    }


    handleCupboardsChange(event) {
        let configuration = this.props.configuration;
        configuration.CupboardsOwnersCabin = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleFabricChange(newValue) {
        let configuration = this.props.configuration;
        configuration.FabricOwnersCabin = newValue;
        configuration.FabricAftCabin = newValue;
        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleBeautytableChange(event) {
        let configuration = this.props.configuration;
        configuration.beautytable = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleWardrobeChange(event) {
        let configuration = this.props.configuration;
        configuration.LargeWardrobe = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = ownerscabinImageOptions;

        let image = <ConfiguratorImage boat="X5_6" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

                    <h1><Trans defaults='Owner’s cabin' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='To add more storage in the owner’s cabin, you have an option for upper cupboards.' /></p>
                    <p><Trans defaults='Optional is beauty table – alternative to this is the optional large wardrobe.' /></p>

                    <Toggle checked={this.props.configuration.CupboardsOwnersCabin.value === 2} onChange={this.handleCupboardsChange}>
                        <Trans defaults='Upper freeboard cabinets above the berth (port & starboard)' />
                    </Toggle>

                    <Toggle disabled={this.props.configuration.LargeWardrobe.value === 2} checked={this.props.configuration.beautytable.value === 2} onChange={this.handleBeautytableChange}>
                        <Trans defaults='Beauty table with hinged mirror and single seat' />
                    </Toggle>

                    <Toggle disabled={this.props.configuration.beautytable.value === 2} checked={this.props.configuration.LargeWardrobe.value === 2} onChange={this.handleWardrobeChange}>
                        <Trans defaults='Large wardrobe – starboard side replacing standard wardrobe.' />
                    </Toggle>

                    <h2><Trans defaults='Fabrics' /></h2>
                    <MaterialSelector options={this.props.fabricOptions} label={this.props.configuration.FabricOwnersCabin.label} value={this.props.configuration.FabricOwnersCabin} onChange={this.handleFabricChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X56OwnersCabin);


// WEBPACK FOOTER //
// ./src/X56/X56OwnersCabin.js